import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaReact } from 'react-icons/fa'
import { BsFillBootstrapFill } from 'react-icons/bs'
import { IoLogoCss3 } from 'react-icons/io'
import { GrHtml5 } from 'react-icons/gr'
import { SiAngularjs } from 'react-icons/si'
import { DiNodejs } from 'react-icons/di'
import { DiMongodb } from 'react-icons/di'
import { IoLogoJavascript } from 'react-icons/io'
import { IoLogoPython } from 'react-icons/io'
import { FiDatabase } from 'react-icons/fi'
import { DiPhotoshop } from 'react-icons/di'
import { DiIllustrator} from 'react-icons/di'
import { SiPostgresql } from 'react-icons/si'
const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3
    }
  };
function OurTechnologies() {
    return (
        <div className="grey lighten-3">
        <div className="container-fluid ">
            <div className="row pt-6">
                <div className="col-sm-12">
                    <h5 className="center green-text text-darken-1 ff-mono">TECHNOLOGIES WE WORK</h5>
                </div>
                <div className="col-sm-12 pt-4">
                    <h1 className="center" style={{fontSize: '3.8rem'}}>
                        Technology is best when it <br/> brings people together.
                    </h1>
                </div>
                <div className="col-sm-12 col-md-6 offset-md-3">
                    <div className="pt-4 mt-4" style={{borderBottom: '1px solid #d3d3d3'}}></div>
                </div>
            </div>

        </div>

        <div className="container ">
            <div className="row">
                <div className="col-sm-12 pt-5  mb-4 pb-4">
                    <Carousel responsive={responsive} className="center" arrows={false} showDots={true}>
                            <span className="grey-text text-darken-2">
                                <FaReact style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">React.js</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <DiNodejs   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Node.js</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <SiAngularjs   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Angular</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <DiMongodb   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Mongodb</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <SiPostgresql  style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Postgre SQL</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <IoLogoJavascript   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Javascript</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <IoLogoCss3  className="grey-text text-darken-2" style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">CSS 3</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <BsFillBootstrapFill   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Bootstrap</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <IoLogoPython   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Python</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <FiDatabase   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Data Science</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <DiPhotoshop   style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Photoshop</h5>
                            </span>
                            <span className="grey-text text-darken-2">
                                <DiIllustrator  style={{fontSize: '5rem'}} />
                                <h5 className="pt-2 pb-5">Illustrator</h5>
                            </span>
                      
                        
                    </Carousel>
                </div>
            </div>
        </div>
    </div>
    )
}

export default OurTechnologies